<template>
  <CHeader position="sticky" class="custom-header">
    <CContainer fluid>
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <div>
        <span class="account-text">{{ $store.state.registeredEmail }}</span>
        <el-button size="small" @click="$store.dispatch('logout')">
          登出
        </el-button>
      </div>
    </CContainer>
    <CHeaderDivider />
    <CContainer fluid>
      <AppBreadcrumb />
    </CContainer>
  </CHeader>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
  },
  setup() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.account-text {
  font-size: 14px;
  margin-right: 24px;
}
.custom-header {
  margin-bottom: 15px;
}
</style>
